import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import amarok from "../../../../assets/info/amarok-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const VWAmarok = () => {
  useSmallNav("Volkswagen Amarok");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Volkswagen Amarok"} bolder />
        <InfoHero image={amarok} />
        <InfoGrid>
          <div>
            <InfoHeader text={"Zestaw podnoszący do VW Amarok"} />
            <p>
              W Pedders od lat interesujemy się terenowymi Volkswagenami i kiedy
              Amarok po raz pierwszy pojawił się na scenie, bardzo chcieliśmy
              zobaczyć, jak radzą sobie w terenie.
            </p>
            <p>
              Połącz zwycięską formułę historii i doświadczenia Volkswagena
              Amaroka i Peddersa, a otrzymasz potężną kombinację!
            </p>
            <p>
              Jesteśmy dumni, że możemy wprowadzić na rynek jeden z pierwszych
              zestawów podnoszących do Amaroka. Nie działamy tutaj półśrodkami,
              a zestaw podnoszący do Amaroka jest tego doskonałym przykładem!
            </p>
            <p>
              Zamiast oferować tylko sprężyny i bloki podnoszące, to
              zdecydowaliśmy zbudować kompletny zestaw dwóch przednich
              wzmocnionych sprężyn, dwóch amortyzatorów gazowych Sports Ryder,
              dwóch tylnych wzmocnionych resorów piórowych i dwóch tylnych
              amortyzatorów Sports Ryder, wszystkie zaprojektowane tak, aby ze
              sobą współdziałały, zapewniając doskonałą jazdę i poprawę we
              wszystkich obszarach.
            </p>
            <p>
              Ponieważ wszystkie produkty Pedders objęte są dwuletnią gwarancją,
              w połączeniu z niezawodnością Volkswagenów możesz mieć pewność, że
              poradzisz sobie nawet w najtrudniejszym terenie, a codzienną pracę
              potraktujesz jak spacer po parku.
            </p>
            <InfoHeader
              size="smaller"
              text={"Przedstawiamy zestawy ekspedycyjne TrakRyder"}
            />
            <p>
              Parametry sprężyn i amortyzatorów zostały opracowane tak, aby
              zapewnić lepszą nośność, z zaletą polegającą na zwiększeniu
              stabilności w wyniku mniejszych przechyleń nadwozia, przy
              jednoczesnym uwzględnieniu komfortu jazdy. Zestaw ten został
              zaprojektowany przede wszystkim w celu przywrócenia nowego
              prześwitu z niewielkim zwiększeniem do 1 cala (25 mm). Zestaw
              ekspedycyjny poprawi także hamowanie i sterowanie pojazdem podczas
              holowania.
            </p>
            <InfoHeader
              size="smaller"
              text={"Czy to będzie pasować do mojego Amaroka?"}
            />
            <p>
              Idealny do przewożenia ciężkich ładunków, holowania pojazdów lub
              przyczep kempingowych i spędzenia weekendu w buszu. Zestaw ten
              będzie odpowiedni dla pojazdów wyposażonych w drążek ze światłami
              drogowymi, standardowe koła i opony oraz dodatkowe wyposażenie,
              takie jak lodówka czy skrzynka narzędziowa, ale nie wyklucza także
              pojazdów z dodatkami, takimi jak: bagażniki dachowe, zbiorniki
              paliwa czy chociażby dodatkowa zabudowa z tyłu.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Volkswagen")
              .models.find((e) => e.display === "Amarok")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/9NU3nn4tX1c"
              title={"Amarok Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Amarok Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Amarok Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Volkswagen" model="Amarok" /> */}
      </Container>
    </section>
  );
};

export default VWAmarok;
